module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Circle-01dba46133d87d619b97bd6e6f47058f.svg";